import { render, staticRenderFns } from "./Revista.vue?vue&type=template&id=f7911fd2&scoped=true"
import script from "./Revista.vue?vue&type=script&lang=ts"
export * from "./Revista.vue?vue&type=script&lang=ts"
import style0 from "./Revista.vue?vue&type=style&index=0&id=f7911fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7911fd2",
  null
  
)

export default component.exports